// extracted by mini-css-extract-plugin
export var videoWrapper = "styles-module--videoWrapper--dkwGn";